<script setup>
  import { StrapiBlocks } from 'vue-strapi-blocks-renderer'

  const config = useRuntimeConfig()

  const { toWebp } = useWebpImage()

  const props = defineProps({
    title: {
      type: String,
      default: ''
    },
    banner: {
      type: Object,
      default: () => {}
    },
    content: {
      type: [String, Array, Object],
      required: false,
      default: () => null
    }
  })

  const baseUrl = computed(() => config.public.strapi)
  const imageSrc = computed(() => {
    return props.banner?.url ? `${baseUrl.value}${props.banner.url}` : '/logo/logo_UIA_Fond_Blanc.PNG'
  })
  const webpUrl = computed(() => toWebp(imageSrc.value))
</script>

<template>
  <div class="relative w-full h-64 md:h-96 flex items-center justify-center">
    <picture>
      <source :srcset="webpUrl" type="image/webp" />
      <img :src="imageSrc" class="object-cover w-full h-full absolute top-0 left-0 z-0" />
    </picture>
    <div class="absolute top-0 left-0 w-full h-full bg-gradient-to-r from-black/60 to-transparent z-0"></div>
    <div class="relative z-10 w-full flex flex-col items-center justify-center h-full">
      <h1 v-if="title" class="text-white text-4xl md:text-6xl font-bold text-center drop-shadow-lg">
        {{ title }}
      </h1>
      <div v-if="content" class="max-w-2xl mx-auto mt-4 text-center banner-content">
        <StrapiBlocks :content="content" />
      </div>
    </div>
  </div>
</template>
